//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeatureList.js";
import "../GeometricUtilities/GeometricUtilities.PatternDefinition.js";
import "../GeometricUtilities/GeometricUtilities.PatternReferencePointServiceBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CreateReferencePattern",1,1],[0,"ExpressionOption",1,0],[1,"FeatureList",0,"Features.SelectFeatureList",0],[0,"OutputOption",1,0],[0,"PatternMethod",1,0],[1,"PatternService",0,"GeometricUtilities.PatternDefinition",0],[0,"ReferencePoint",1,"Point",1],[1,"ReferencePointService",0,"GeometricUtilities.PatternReferencePointServiceBuilder",0],[0,"UseInferredReferencePoint",1,1]],[[["inputFeature","referencesFromInputFeatures"],"SetReferencesToReuse",{},2,0],[[],"ClearReferencesToReuse",{},0,0],[[],"RemoveAllClocking",{},0,0]],[]];
SPLM.Features.PatternFeatureBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.PatternFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.PatternFeatureBuilder.PatternMethodOptions = Object.freeze({
    "Variational" : "Variational", "Simple" : "Simple", "SingleOutput" : "SingleOutput"});

SPLM.Features.PatternFeatureBuilder.OutputOptions = Object.freeze({
    "PatternFeature" : "PatternFeature", "CopiesOfInputFeatures" : "CopiesOfInputFeatures", "CopiesOfInputFeaturesInGroup" : "CopiesOfInputFeaturesInGroup"});

SPLM.Features.PatternFeatureBuilder.ExpressionTransferOptions = Object.freeze({
    "CreateNew" : "CreateNew", "LinkToOriginal" : "LinkToOriginal", "OriginalInstance" : "OriginalInstance"});

export default SPLM;